import { Directive, ElementRef, HostListener, DoCheck, Optional, HostBinding } from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
  selector: '[appLabelFloat]',
})
export class LabelFloatDirective implements DoCheck {
  @HostBinding('class.ey-field') field: boolean;
  @HostBinding('class.ey-field-active') active: boolean;
  @HostBinding('class.ey-field-populated') populated: boolean;

  constructor(public el: ElementRef, @Optional() public ngModel: NgModel) {
    this.field = true;
  }

  ngDoCheck() {
    this.updatePopulatedState();
  }

  // To trigger change detection to manage ui-state-filled for material labels when there is no value binding
  @HostListener('input', ['$event'])
  onInput() {
    this.updatePopulatedState();
  }

  @HostListener('focus', ['$event'])
  onFocus() {
    this.active = true;
  }

  @HostListener('blur', ['$event'])
  onBlur() {
    this.active = false;
    this.updatePopulatedState();
  }

  updatePopulatedState() {
    this.populated = false;
    switch (this.el.nativeElement.tagName) {
      case 'SELECT':
        if (this.el.nativeElement.selectedIndex !== -1) {
          const selectedValue = this.el.nativeElement.options[this.el.nativeElement.selectedIndex].value;
          if (selectedValue && selectedValue !== '' && selectedValue !== 'undefined') {
            this.populated = true;
          }
        }
        // console.log(`updatePopulatedState - [tag=${this.el.nativeElement.tagName},selected=${this.el.nativeElement.selectedOptions},state=${this.populated}]`);
        break;
      case 'P-DROPDOWN':
      case 'P-CALENDAR':
      case 'P-AUTOCOMPLETE':
        if (this.ngModel && this.ngModel.model) {
          this.populated = true;
        }
        break;
      default:
        if (this.el.nativeElement.value !== undefined && this.el.nativeElement.value.length > 0) {
          this.populated = true;
        }
        // console.log(`updatePopulatedState - [tag=${this.el.nativeElement.tagName},value=${this.el.nativeElement.value},state=${this.populated}]`);
        break;
    }
  }
}
